import React from "react";
import "./attachmentContainer.css";

/**
 * 파일 목록 + 기본 file input
 */
export default function AttachmentListUploader({
    readOnly,
    inputId,
    inputAccept,
    onInputChange,
    fileList,
    hasFiles,
    emptyLabel = "",
    className = "",
}) {
    return (
        <div className={`attch-uploader ${className}`.trim()}>
            {hasFiles ? (
                <div className="attch-uploader__list">{fileList}</div>
            ) : readOnly ? (
                <p className="attch-empty">{emptyLabel}</p>
            ) : null}

            {!readOnly && (
                <div className="attch-input-bar">
                    <input
                        id={inputId}
                        type="file"
                        multiple
                        accept={inputAccept}
                        onChange={onInputChange}
                    />
                </div>
            )}
        </div>
    );
}
